import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import VueRouter from 'vue-router'

import Home from './views/Home';
import About from './views/About';
import Contact from './views/Contact';
import NotFound from './views/NotFound';
import Success from './views/Success';

Vue.use(VueRouter)

import './scss/main.scss';

Vue.config.productionTip = false

const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact },
    { path: '*', component: NotFound },
    { path: '/success', component: Success }
  ]
})

// import Toaster from 'v-toaster'
// import 'v-toaster/dist/v-toaster.css'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: "UA-201816971-1" }
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
